import { SaloonInvitesCacheService as Cache } from "./cache";

export const SaloonInviteMutationHandler = {
  removed({ invite }) {
    Cache.removeInvite({ id: invite._id, saloon: invite.saloon });
  },
  statusChanged({ invite }) {
    const saloonId = invite.saloon;
    const status = invite.status;
    Cache.updateInvite({
      id: invite._id,
      saloonId,
      updates: {
        status,
      },
    });
  },
};
